export default __webpack_public_path__ + "4083f65c957973db462b9d928aed19ec.svg";